import { Component, Injector, Input, OnInit } from '@angular/core';
import { PractitionerSecretariesAffiliationService } from 'app/core/http/services/practititoner-secretaries-affiliation.service';
import { SecretaryService } from 'app/core/http/services/secretary.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { mergeMap } from 'rxjs';
import { telecom } from 'app/core/models/Organization';

@Component({
  selector: 'page-secretary-contacts',
  templateUrl: './secretary-contacts.component.html',
  styleUrls: ['./secretary-contacts.component.scss'],
})
export class SecretaryContactsComponent
  extends BaseComponent
  implements OnInit
{
  @Input() type: 'Consulta' | 'Exame' = 'Consulta';
  @Input() id: number = 0;
  @Input() secretaries: any[] = [];

  public affilationsSecretary: any[] = [];
  public affiliations: any[] = [];
  public secretariesAffiliation: any[] = [];
  public secretaryActive: any[] = [];

  constructor(
    private injector: Injector,
    private affiliationPractitionerSecretaryService: PractitionerSecretariesAffiliationService,
    private secretariesService: SecretaryService
  ) {
    super(injector);
  }

  async ngOnInit() {
    await this.getSecretary();
  }

  private async getSecretary() {
    const practitioner_id = this.id;

    this.secretariesService
      .list()
      .pipe(
        mergeMap((secretaries) => {
          const secretariesArray = Object.values(secretaries);

          this.secretaries = secretariesArray;

          return this.affiliationPractitionerSecretaryService.listByPractitioner(
            practitioner_id
          );
        })
      )
      .subscribe((affiliations) => {
        const affiliationArray = Object.values(affiliations);
        this.affilationsSecretary = this.transformFhirToModel(affiliationArray);

        this.secretariesAffiliation = this.getSecretariesAffiliations();

        this.getSecretariesActive();
      });
  }

  getSecretariesActive() {
    const secretaries = [...this.secretariesAffiliation];
    this.secretaryActive = secretaries.filter(
      (item: any) => item.statusAffiliation === 'accepted'
    );

    console.log('Secretárias afiliadas', this.secretaryActive);
  }

  getSecretariesAffiliations() {
    const secretariesIdsAffiliation = new Set(
      this.affilationsSecretary.map((objeto) => objeto.secretary_id)
    );

    const secretaries = this.secretaries.filter((objeto) =>
      secretariesIdsAffiliation.has(objeto.secretaries_id)
    );

    const mapaSecretaryIdPrimeiroObjeto = new Map(
      this.affilationsSecretary.map((objeto) => [objeto.secretary_id, objeto])
    );

    const secretariesAffiliation = secretaries.map((objeto) => ({
      ...(mapaSecretaryIdPrimeiroObjeto.get(objeto.secretaries_id) || {}),
      ...objeto,
    }));

    return secretariesAffiliation;
  }

  transformFhirToModel(jsonData: any[]) {
    const transformedFhir = jsonData.map((item) => {
      const {
        affiliation_id,
        request: { id: secretary_id, display: secretary_name },
        subject: { id: organization_id, display: organization_name },
        status: statusAffiliation,
      } = item;

      return {
        affiliation_id,
        secretary_name,
        secretary_id,
        organization_name,
        organization_id,
        statusAffiliation,
      };
    });

    return transformedFhir;
  }

  public transformObjectToFHIR(data: any) {
    const transformedData = {
      resourceType: 'Affiliation',
      affiliation_id: data.affiliation_id,
      request: {
        id: data.secretary_id,
        referenceType: 'Secretary',
        display: data.secretary_name,
      },
      subject: {
        id: data.organization_id,
        referenceType: 'Organization',
        display: data.organization_name,
      },
      status: data.status,
      requestDateTime: data.requestDateTime,
      updateDateTime: data.updateDateTime,
    };

    return transformedData;
  }

  extractContactInfo(telecom: telecom[]) {
    let email: string | null = null;
    let phone: string | null = null;
    let mobile: string | null = null;

    telecom.forEach((telecom) => {
      const { value, use, system } = telecom;
      if (system === 'email') {
        email = value;
      } else if (system === 'phone') {
        phone = value;
      } else if (system === 'mobile') {
        mobile = value;
      }
    });
    return { email, phone, mobile };
  }
}
